import points from '../Assets/icons/threepoints.svg'
import arrowUp from '../Assets/icons/arrowUp.svg'
import arrowDown from '../Assets/icons/arrowDown.svg'
import walletIcon from '../Assets/icons/walletIcon.svg'
import { useAuth } from '../Contexts/AuthContext'
import { useEffect } from 'react'
const SaidasComponent = ({userData}) => {
    if (userData == null) {
        return <div className='w-full h-screen bg-[#171717]'>
            loading...
        </div>
    }
    return (
        <div>
            <div className="w-full mt-4 gap-4 grid md:grid-cols-3">
                <div className="w-full p-4 border rounded-[10px] border-[#343B4F]">
                    <div className='flex w-full justify-between'>
                        <div className='flex text-[13px] text-[#AEB9E1] gap-1'>
                            <img src={walletIcon} />
                            <p>Quantidade de saques</p>
                        </div>
                        <img src={points} />
                    </div>
                    <div className='flex gap-2 mt-4 items-center'>
                        <p className='text-[20px]'>{userData.quantidadeSaques}</p>
                        <div className='rounded-[5px] text-[10px] items-center flex px-1 flex-shrink h-[80%] py-1 text-[#14CA74] hidden bg-[#14CA742D]'>
                            28.84%
                        </div>
                    </div>
                </div>
                <div className="w-full p-4 border rounded-[10px] border-[#343B4F]">
                    <div className='flex w-full justify-between'>
                        <div className='flex text-[13px] text-[#AEB9E1] gap-1'>
                            <img src={walletIcon} />
                            <p>Total sacados</p>
                        </div>
                        <img src={points} />
                    </div>
                    <div className='flex gap-2 mt-4 items-center'>
                        <p className='text-[20px]'>R$ {userData.saques}</p>
                        <div className='rounded-[5px] text-[10px] hidden items-center flex px-1 flex-shrink h-[80%] py-1 text-[#FF5A65] bg-[#FF5A652D]'>
                            28.84%
                        </div>
                    </div>
                </div>
                <div className="w-full p-4 border rounded-[10px] border-[#343B4F]">
                    <div className='flex w-full justify-between'>
                        <div className='flex text-[13px] text-[#AEB9E1] gap-1'>
                            <img src={walletIcon} />
                            <p>Ticket médio</p>
                        </div>
                        <img src={points} />
                    </div>
                    <div className='flex gap-2 mt-4 items-center'>
                        <p className='text-[20px]'>R$ {userData.saques > 0 && userData.quantidadeSaques > 0 ? (userData.saques / userData.quantidadeSaques).toFixed(2) : 0}</p>
                        <div className='rounded-[5px] text-[10px] items-center flex px-1 flex-shrink h-[80%] py-1 text-[#14CA74] hidden bg-[#14CA742D]'>
                            28.84%
                        </div>
                    </div>
                </div>
                {/* <div className="w-full p-4 border rounded-[10px] border-[#343B4F]">
                    <div className='flex w-full justify-between'>
                        <div className='flex text-[13px] text-[#AEB9E1] gap-1'>
                            <img src={walletIcon} />
                            <p>Tarifas de saque</p>
                        </div>
                        <img src={points} />
                    </div>
                    <div className='flex gap-2 mt-4 items-center'>
                        <p className='text-[20px]'>R$ 0.00</p>
                        <div className='rounded-[5px] text-[10px] items-center flex px-1 flex-shrink h-[80%] py-1 text-[#14CA74] hidden bg-[#14CA742D]'>
                            28.84%
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default SaidasComponent